import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { RouteLocation, Router, type RouteLocationAsRelative } from 'vue-router';

const pdpPrefixMap = {
  [OfferType.Buy]: {
    [HgSupportedLanguage.EN]: 'buy',
    [HgSupportedLanguage.DE]: 'kaufen',
    [HgSupportedLanguage.FR]: 'acheter',
    [HgSupportedLanguage.IT]: 'acquistare',
  },
  [OfferType.Rent]: {
    [HgSupportedLanguage.EN]: 'rent',
    [HgSupportedLanguage.DE]: 'mieten',
    [HgSupportedLanguage.FR]: 'louer',
    [HgSupportedLanguage.IT]: 'affittare',
  },
};

export function getPdpRoute({
  offerType,
  language,
  listingId,
}: {
  offerType?: OfferType;
  language: HgSupportedLanguage;
  listingId: string;
}): string {
  const fallbackOfferType = offerType ?? OfferType.Rent; // we should default to Rent if offerType is undefined
  return `${import.meta.env.VUE_APP_BASE_URL}/${pdpPrefixMap[fallbackOfferType][language]}/${listingId}`;
}

export function getPageRoute(
  pageName: string,
  language: HgSupportedLanguage,
  offerType?: OfferType,
  options?: object,
): RouteLocationAsRelative {
  return {
    name: `${pageName}${offerType ? '-' + offerType : ''}-${language}`,
    ...options,
  };
}

export function normalizedFullPath(route: RouteLocation, router: Router): string {
  const normalizedPageRoute = {
    params: route.params,
    ...getPageRoute(route.name?.split('-')[0] || '', HgSupportedLanguage.EN, route.meta?.offerType),
  };
  const resolvedRoute = router.resolve(normalizedPageRoute);

  if (!resolvedRoute) {
    return '';
  }

  return resolvedRoute?.fullPath ?? '';
}
